// @ts-nocheck
import styled from 'styled-components'
import diamond from 'kittyFamily/svg/diamond.svg'
import gilded from 'kittyFamily/svg/gilded.svg'
import amethyst from 'kittyFamily/svg/amethyst.svg'
import lapis from 'kittyFamily/svg/lapis.svg'

export const Div = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  max-width: 100%;
  min-height: 20px;
  box-sizing: border-box;
`

export const Jewel = styled.div`
  position: relative;
  cursor: ${({ type }) => type === 'none' ? 'default' : 'pointer'};
  ${({ displayType, type }) => displayType === 'family-jewels' && type !== 'none' ? `
    width: 14px;
    height: 14px;
    flex: 0 0 14px;
    &:before {
      display: none;
    }
  ` : `
    &:before {
      content: '';
      display: block;
      padding-top: 100%;
    }
  `}
  background-image: ${({ type }) => {
    switch(type) {
      case 'diamond':
        return `url('${diamond}')`
      case 'gilded':
        return `url('${gilded}')`
      case 'amethyst':
        return `url('${amethyst}')`
      case 'lapis':
        return `url('${lapis}')`
      default:
        return 'none'
    }
  }};
  background-size: ${({ displayType, type }) => displayType === 'family-jewels' && type !== 'none' ? 'contain' : '100% auto'};
  background-position: center;
  background-repeat: no-repeat;
  &:after {
    content: '${({ trait }) => trait}';
    opacity: 0;
    position: absolute;
    left: -50%;
    top: ${({ displayType }) => displayType === 'mewtations' ? '-20px' : '20px'};
    font-size: 12px;
    font-weight: normal;
    background-color: #FFF;
    padding: 2px 6px;
    z-index: 100;
    border-radius: 4px;
  }
  &:hover {
    &:after {
      opacity: ${({ type }) => type === 'none' ? 0 : 1};
    }
  }
`
